import { create } from 'zustand';
import { ApiUtils, ApplicationApi, RequestStrategyEnum } from '@shared/api';

interface IRejectCreditLimitStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  rejectCreditLimit: (applicationId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRejectCreditLimitStore = create<IRejectCreditLimitStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  rejectCreditLimit: ApiUtils.wrapperApi(async (applicationId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.rejectCreditLimit(applicationId, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
